import Papa from 'papaparse';

const getString = (data, headers, titleLine = null) => {
  const fields = Object.keys(headers || data[0]);
  const head = fields.map((key) => getColumnTitle(headers, key)).join(',') + '\n';
  const rows = data
    .map((datum) => fields.map((key) => getCellValue(headers, datum, key)).join(','))
    .join('\n');
  const title = titleLine ? `${titleLine}\n` : '';
  return title + head + rows;
};

const getColumnTitle = (headers, key) => headers?.[key]?.title || headers?.[key] || key;

function getCellValue(headers, datum, key) {
  const rawValue = headers?.[key]?.getValue ? headers?.[key]?.getValue(datum) : datum[key] ?? '';
  const valueAsString = typeof rawValue === 'object' && rawValue !== null ? JSON.stringify(rawValue) : String(rawValue);
  const escaped = valueAsString.replace(/"/g, '""');
  const needsQuotes = /[",\n]/.test(escaped);
  return needsQuotes ? `"${escaped}"` : escaped;
}

function parseCsvFile(csvFile) {
  return new Promise((resolve) => {
    Papa.parse(csvFile, {
      header: true,
      skipEmptyLines: true,
      transformHeader: function (header) {
        if (typeof header !== 'string') return '';
        return header.toLowerCase().replace(/[^a-z0-9]/g, '');
      },
      complete: function (results) {
        resolve(results.data);
      },
    });
  });
}

const CsvHelper = { getString, parseCsvFile };
export default CsvHelper;
